<template>
    <div class="border border-gray-300 bg-gray-warm-50 rounded-md px-6 py-5">
        <div class="flex items-end">
            <div class="flex-1">
                <h2 class="text-gray-400 text-lg font-semibold pb-3">
                    Status
                </h2>

                <div class="flex items-center pl-2">
                    <div class="text-md">
                        <div v-if="envelope_completed_at"
                            class="text-blue-600"
                        >
                            Completed on <span class="font-bold">{{ completed_at_date_formatted_date }}</span>
                            at <span class="font-bold">{{ completed_at_date_formatted_time }}</span>
                        </div>

                        <div v-else-if="envelope_sent_at"
                            class="text-green-warm-600"
                        >
                            Sent on <span class="font-bold">{{ sent_at_date_formatted_date }}</span>
                            at <span class="font-bold">{{ sent_at_date_formatted_time }}</span>
                        </div>

                        <div v-else
                            class="pl-6 text-gray-500"
                        >
                            Unsent
                        </div>
                    </div>

                    <div v-if="fetching"
                        class="ml-3"
                    >
                        <i class="text-green-warm-500 text-sm fas fa-spin fa-sync" aria-hidden="true" />
                    </div>
                </div>
            </div>

            <div class="flex-none">
                <div class="flex flex-1 pl-12">
                    <button-blue-outline v-if="envelope_sent_at"
                        @click="viewDocusign"
                    >
                        View in DocuSign
                    </button-blue-outline>

                    <button-blue-outline v-else-if="envelopes_available"
                        @click="viewDocusign"
                    >
                        Send with DocuSign
                    </button-blue-outline>

                    <div v-else
                        class="flex flex-col items-end"
                    >
                        <p class="text-sm text-blue-600 font-semibold mb-2">
                            To send this envelope, purchase additional DocuSign credit.
                        </p>

                        <button-blue-outline @click="purchaseDocusignCredit">
                            Purchase DocuSign Credit
                        </button-blue-outline>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonBlue from '../../../components/button-blue.vue';
import ButtonBlueOutline from '../../../components/button-blue-outline.vue';

export default {
    components: {
        ButtonBlue,
        ButtonBlueOutline,
    },

    props: {
        envelope: {},
        envelopes_available: {},
        signature_purchase_route: {},
    },

    data() {
        return {
            fetching: false,
            envelope_status: this.envelope.status,
            envelope_sent_at: this.envelope.sent_at,
            envelope_completed_at: this.envelope.completed_at,
        }
    },

    computed: {
        sent_at_date_formatted_date() {
            return this.envelope_sent_at ? dayjs(this.envelope_sent_at).format('M/D/YYYY') : null;
        },
        sent_at_date_formatted_time() {
            return this.envelope_sent_at ? dayjs(this.envelope_sent_at).format('h:mm A') : null;
        },
        completed_at_date_formatted_date() {
            return this.envelope_completed_at ? dayjs(this.envelope_completed_at).format('M/D/YYYY') : null;
        },
        completed_at_date_formatted_time() {
            return this.envelope_completed_at ? dayjs(this.envelope_completed_at).format('h:mm A') : null;
        },
    },

    methods: {
        viewDocusign() {
            this.$emit('viewDocusign');
        },
        getEnvelopeStatus() {
            this.fetching = true;

            axios.get(this.envelope.status_route)
                .then(response => {
                    this.envelope_status = response.data.status;
                    this.envelope_sent_at = response.data.sent_at;
                    this.envelope_completed_at = response.data.completed_at;
                    this.$emit('recipientStatusUpdated', response.data.signers);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(error => {
                    this.fetching = false;
                });
        },
        purchaseDocusignCredit() {
            window.location.href = this.signature_purchase_route;
        },
    },

    created() {
        if (this.envelope.sent_at && ! this.envelope.completed_at) {
            this.getEnvelopeStatus();
        }
    },
}
</script>
